import { useEffect, useState } from 'react';
import { getHealth } from '../lib/api.js';

type State = { kind: 'loading' } | { kind: 'up' } | { kind: 'down'; message: string };

/**
 * The step-1 end-to-end check: browser → Caddy → Fastify. If this reads "API
 * reachable" in a browser pointed at the deployed host, the spine is wired.
 */
export function HealthBadge() {
  const [state, setState] = useState<State>({ kind: 'loading' });

  useEffect(() => {
    let cancelled = false;
    getHealth()
      .then(() => {
        if (!cancelled) setState({ kind: 'up' });
      })
      .catch((error: unknown) => {
        if (!cancelled) {
          setState({ kind: 'down', message: error instanceof Error ? error.message : 'Unknown' });
        }
      });
    // StrictMode double-invokes effects in development; the flag keeps the
    // unmounted render from setting state.
    return () => {
      cancelled = true;
    };
  }, []);

  if (state.kind === 'loading') return <p className="muted">Checking the API…</p>;
  if (state.kind === 'down')
    return <p className="status status--down">API unreachable: {state.message}</p>;
  return <p className="status status--up">API reachable</p>;
}
